export function showCustomLogo(companyId) {
  const companiesIds = [
    "50dd211f-bf81-4c73-b9de-84d72c0f4543", // Glovo
    "d7edfe6e-ad45-4b05-9d0f-9c7ebb958b92", // Glovo Infrastructure
    "1e7384bc-c9c2-4437-b03a-2e3a7ceeb590", // Glovo International
    "eb5fecc5-1934-4830-8f70-849c319277f7", // Glovo LATAM
    "a02f3e6b-62dc-473e-b90d-7474df2e213a", // GLOVOAPP EMEA
  ];
  return companiesIds.some((id) => id === companyId);
}

export function showIFeelFeature(companyId) {
  const companiesIds = [
    "50dd211f-bf81-4c73-b9de-84d72c0f4543", // Glovo
    "d7edfe6e-ad45-4b05-9d0f-9c7ebb958b92", // Glovo Infrastructure
    "1e7384bc-c9c2-4437-b03a-2e3a7ceeb590", // Glovo International
    "eb5fecc5-1934-4830-8f70-849c319277f7", // Glovo LATAM
    "a02f3e6b-62dc-473e-b90d-7474df2e213a", // GLOVOAPP EMEA
  ];

  return companiesIds.some((id) => id === companyId);
}

export function showAllExpense(companyId) {
  const companiesIds = [
    "81ab4b3c-27c7-4327-ad4c-e311a54bd692", // Telefonica
    "069c2a25-7bd9-4220-a4b5-f18c74b163a6", // Avanade
    "beb273d1-a4ac-4f2d-bd21-4631d839892c", // Scopely
    "8eaed664-4360-4539-a233-14d0f94e245a", // Genjoy
    "5abd4b57-7ccb-4689-876c-3db385242a0c", // Genera Games
    "c3f57717-ef96-4fac-872e-27f7de2cff70", // Ília
    "bf5d8a64-4220-47d7-b64c-25f235e1de08", // Ritmo
    "f9e8baf0-8a62-4128-b123-e72e4a97eee4", // Ontruck
    "b1d8d3bf-263e-4a86-99d7-57022c019875", // L'Oréal España
    "e38fffb3-5247-42c3-a47a-0ea0c0567d26", // Digital Smile Design
  ];

  return companiesIds.some((id) => id === companyId);
}
